var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCcMastercardDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.6667,
    height: 31,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.667 22.876C22.0782 24.247 20.0173 25.0747 17.7654 25.0747C12.7405 25.0747 8.66699 20.9539 8.66699 15.8707C8.66699 10.7875 12.7405 6.66675 17.7654 6.66675C20.0173 6.66675 22.0782 7.49442 23.667 8.86546C25.2558 7.49442 27.3167 6.66675 29.5686 6.66675C34.5935 6.66675 38.667 10.7875 38.667 15.8707C38.667 20.9539 34.5935 25.0747 29.5686 25.0747C27.3167 25.0747 25.2558 24.247 23.667 22.876Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.667 22.876C25.6233 21.1878 26.8637 18.6758 26.8637 15.8707C26.8637 13.0656 25.6233 10.5536 23.667 8.86546C25.2558 7.49442 27.3167 6.66675 29.5686 6.66675C34.5935 6.66675 38.667 10.7875 38.667 15.8707C38.667 20.9539 34.5935 25.0747 29.5686 25.0747C27.3167 25.0747 25.2558 24.247 23.667 22.876Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6674 8.86549C25.6236 10.5537 26.8641 13.0657 26.8641 15.8707C26.8641 18.6758 25.6236 21.1878 23.6674 22.876C21.7111 21.1878 20.4707 18.6758 20.4707 15.8707C20.4707 13.0657 21.7111 10.5537 23.6674 8.86549Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcMastercardDefault);
export default __webpack_public_path__ + "static/media/cc_mastercard_default.e959e24a6daf818f1d144921b49eefed.svg";
export { ForwardRef as ReactComponent };